/**
 * The QR upload landing page's address (PROD-10111).
 *
 * The designer's tablet encodes `<origin>/upload?token=<token>` as a QR code;
 * the customer's phone opens it. `main.tsx` checks the path BEFORE choosing a
 * root so the phone never boots the app's auth / client providers — the page
 * is public, the token is its only credential. Kept dependency-free so that
 * check doesn't pull the service layer into the entry chunk.
 */

/** The path the QR's landing URL points at. */
export const UPLOAD_LANDING_PATH = '/upload';

/** The query parameter the landing URL carries the session token in. */
export const UPLOAD_TOKEN_PARAM = 'token';

/** True for `/upload` and `/upload/` (not `/uploads`, not `/upload/x`). */
export function isUploadLandingPath(pathname: string): boolean {
    return pathname === UPLOAD_LANDING_PATH || pathname === `${UPLOAD_LANDING_PATH}/`;
}

/** Read the token from a `location.search` string. Null when absent/blank. */
export function readUploadToken(search: string): string | null {
    const token = new URLSearchParams(search).get(UPLOAD_TOKEN_PARAM)?.trim();
    return token ? token : null;
}

/** Minutes a QR code lives (PROD-10109: 15, one use). Copy only: countdowns and
 *  expiry always run off the session's own `expires_at`. */
export const UPLOAD_SESSION_MINUTES = 15;

/** 599 -> "09:59", as the comps show the "Code expires in" countdown on both devices. */
export function formatCountdown(totalSeconds: number): string {
    const s = Math.max(0, Math.floor(totalSeconds));
    return `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`;
}
